export const FOLLOWING_RECOMMENDATIONS_LOADING = 'following_recommendations.loading';
export const FOLLOWING_RECOMMENDATIONS_LOADED = 'following_recommendations.loaded';
export const FOLLOWING_RECOMMENDATIONS_FOLLOWED = 'following_recommendations.followed';
export const FOLLOWING_RECOMMENDATIONS_UNFOLLOWED = 'following_recommendations.unfollowed';
export const FOLLOWING_RECOMMENDATIONS_ERROR = 'following_recommendations.error';
export const FOLLOWING_RECOMMENDATIONS_RESET = 'following_recommendations.reset';



// WEBPACK FOOTER //
// ./src/stores/follow_recommendation/action_types.js